import React, { useEffect } from "react"
import moment from "moment-timezone"
import img1 from "../../../../static/images/logo.svg"
import img3 from "../../../../static/images/calendar.svg"
import img4 from "../../../../static/images/clock.svg"
import img5 from "../../../../static/images/location_on.svg"
import pana from "../../../../static/images/pana.webp"
import wvConfirmedScript from "./wvConfirmedScript"

const Thankyou = () => {
  const timeZone = moment.tz.guess()
  const tzAbbr = moment().tz(timeZone).format("z")
  const axon_time = JSON.parse(localStorage.getItem("axon_time"))
  useEffect(() => {
    window.location.hash = "#wv-confirmed"
    const appendScript = scriptPath => {
      const script = document.createElement("script")
      script.type = "text/javascript"
      script.async = true
      script.innerHTML = scriptPath
      document.head.appendChild(script)
    }
    appendScript(wvConfirmedScript)
  }, [])
  return (
    <>
      <section className="thankyou-section">
        <div className="container">
          <div className="wv-flex">
            <div className="col-md-3 mx-auto">
              <div className="img-wrap">
                <img alt="" className="img-fluid d-block mx-auto" src={img1} />
              </div>
            </div>
          </div>
          <div className="wv-flex">
            <div className="wv-body-content">
              <div className="section-heading">
                <h3>Welcome Visit Confirmation</h3>
              </div>
              <div className="section-content wv">
                <div className="confirmation-img">
                  <img alt="confirmation-img" src={pana}></img>
                </div>
                <div className="wv-conf-container">
                  <div className="wv-conf-card">
                    <h5>Welcome Visit</h5>
                    <h6>
                      <img alt="" className="img-fluid" src={img3} />
                      <span className="insurance-title">{axon_time.date}</span>
                    </h6>
                    <h6>
                      <img alt="" className="img-fluid" src={img4} />
                      <span className="insurance-title">
                        {axon_time.starttime} - {axon_time.endtime} {tzAbbr}
                      </span>
                    </h6>
                    <h6>
                      <img alt="" className="img-fluid" src={img5} />
                      <span className="insurance-title">Telehealth</span>
                    </h6>
                  </div>
                  <div className="wv-conf-text">
                    <p>
                      Thank you for taking the time to register and schedule
                      your Welcome Visit appointment.
                    </p>
                    <p>Your Welcome Visit is confirmed!</p>
                    <p>
                      If you have any questions before your appointment, please
                      call our Enrollment Team at{" "}
                      <a href="tel:888-885-5068">(888) 885-5068</a>.
                    </p>
                    <p>
                      For Telehealth appointments, a Zoom link will be emailed
                      48 hours prior to the appointment.
                    </p>
                  </div>
                </div>
              </div>
              <div className="btn-wrap text-end">
                <a href="/">
                  <button className="btn btn-home">Home</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default Thankyou
